export type AppSection = 'admin' | 'developer';

function under(pathname: string, base: string): boolean {
    return pathname === base || pathname.startsWith(`${base}/`);
}

/**
 * The app a path belongs to: the admin app, the developer portal, or neither
 * (the welcome page, login). The header picks its logo, its nav and the
 * current app in the account menu from it.
 */
export function sectionOf(pathname: string): AppSection | null {
    if (under(pathname, '/admin')) return 'admin';
    if (under(pathname, '/developer')) return 'developer';
    return null;
}
